<template>
  <div id="app">
    <!-- <Header /> -->
    <router-view :key="$route.fullPath"/>
  </div>
</template>
<script>
export default {
  name: "app",
  components: {
  }
}
</script>
<style>

body {
  background-color: #ce9d4a;
}
#app {
  font-family: 'Ubuntu', sans-serif;
    font-weight: 500;
  color: black;
  background-color: #ce9d4a;
}
.header {
  position: fixed;
  top: 0;
  width: 100%;
  height: 80px;
  z-index: 999;
  background-color: #ce9d4a;
}
  .header .sensors {
    position: absolute;
    padding: 5px;
    height: 60px;
    width: 100%;
    top: 10px;
    /* align-items: center; */
  }
  .header .sensors img {
    height: 45px;
    width: auto;
    margin-right: 0;
  }
  .header .buttonboard {
    position: absolute;
    right: 5%;
    top: 20px;
    width: auto;
    height: 45px;
  }
  .header .divider {
    width: 100%;
    position: absolute;
    top: 70px;
  }
  .header .divider hr {
    /* margin-top: 5px; */
    width: 90%;
  }
</style>
